export default "__VITE_ASSET__BKt8jFgb__"